import { EU_STORES, ReebeloStoreT } from '@lambda/reebelo';

export type ComplianceInfoT = {
  manufacturer: string;
  brand: string;
  contact: string;
  address: string;
};

export const COMPLIANCE_BRANDS: Record<string, ComplianceInfoT> = {
  apple: {
    manufacturer: 'Apple Inc.',
    brand: 'Apple',
    contact: 'support@apple.com',
    address:
      'Hollyhill Industrial Estate, Hollyhill, Cork, Republic of Ireland',
  },
  google: {
    manufacturer: 'Google LLC',
    brand: 'Google',
    contact: 'support@google.com',
    address: 'Gordon House, Barrow Street, Dublin 4, Ireland',
  },
  oneplus: {
    manufacturer: 'OnePlus Technology (Shenzhen) Co., Ltd.',
    brand: 'OnePlus',
    contact: 'support@oneplus.com',
    address:
      '18F, Tairan Building, Block C, Tairan 8th Road, Chegongmiao, Futian District, Shenzhen, China',
  },
  lenovo: {
    manufacturer: 'Lenovo Group Ltd.',
    brand: 'Lenovo',
    contact: 'support@lenovo.com',
    address:
      'Lenovo Technology B.V., Weena 455, 3013 AL Rotterdam, Netherlands',
  },
  acer: {
    manufacturer: 'Acer Inc.',
    brand: 'Acer',
    contact: 'support@acer.com',
    address:
      'Acer House, Heathrow Boulevard, 282 Bath Road, West Drayton, UB7 0DQ, UK',
  },
  asus: {
    manufacturer: 'ASUSTeK Computer Inc.',
    brand: 'Asus',
    contact: 'support@asus.com',
    address:
      'Pegasus House, 1 Bromsgrove Road, Redditch, Worcestershire, B97 4RN, UK',
  },
  microsoft: {
    manufacturer: 'Microsoft Corp.',
    brand: 'Microsoft',
    contact: 'customer.service@microsoft.com',
    address:
      'Microsoft Campus, Thames Valley Park, Reading, Berkshire, RG6 1WG, UK',
  },
};

/**
 * Manufacturer details for the "EU Certification" popup, or null when the
 * popup must not render. Shown on the UK store (RT-14794) and on every EU
 * store (RT-17189) — keyed on EU_STORES so a new EU market inherits it — and
 * only for brands present in COMPLIANCE_BRANDS; the CTA hides otherwise.
 */
export const getComplianceInfo = (
  store: ReebeloStoreT,
  brandName: string | null | undefined,
): ComplianceInfoT | null => {
  if (store !== 'reebelo-uk' && !EU_STORES.includes(store)) {
    return null;
  }

  return COMPLIANCE_BRANDS[(brandName ?? '').toLowerCase()] ?? null;
};
